import { useAuth } from "@/contexts/AuthContext";
import {
  SidebarProvider,
  SidebarInset,
  SidebarTrigger,
  useImportedSidebar,
} from "@/components/ui/sidebar";
import { useLocation } from "react-router-dom";
import AppSidebar from "@/components/layout/AppSidebar";

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  // Collapse sidebar by default for chat assistant details pages
  const isChatAssistantDetailsPage =
    location.pathname.startsWith("/chat-assistants/") &&
    location.pathname !== "/chat-assistants";

  return (
    <SidebarProvider defaultOpen={!isChatAssistantDetailsPage}>
      <MainLayoutContent>{children}</MainLayoutContent>
    </SidebarProvider>
  );
};

const MainLayoutContent = ({ children }: { children: React.ReactNode }) => {
  const { open } = useImportedSidebar();

  return (
    <div
      className="flex h-screen w-full bg-white overflow-hidden"
      style={
        {
          "--sidebar-width": open ? "220px" : "60px",
          "--sidebar-width-icon": open ? "220px" : "60px",
          "--sidebar-width-mobile": open ? "200px" : "60px",
          "--sidebar-width-icon-mobile": open ? "200px" : "60px",
        } as React.CSSProperties
      }
    >
      <AppSidebar />
      <SidebarInset className="p-0 w-full flex-1 flex flex-col overflow-x-hidden overflow-y-auto">
        {children}
      </SidebarInset>
    </div>
  );
};

export default MainLayout;
